/**
 * KCIS Assessment Monetization · API client.
 *
 * Thin axios wrapper for `/api/assessment-purchases/*`. Never imports or
 * mutates the existing assessment session helpers — used ONLY by the new
 * tier shell + `/assessment-purchased` success page.
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/assessment-purchases`;

export const TIER_SESSION_KEY = "kcis_assessment_tier_v1";

export const assessmentPurchaseApi = {
  // Public
  tiers: () => axios.get(`${API}/tiers`),
  create: (payload) => axios.post(`${API}/`, payload),
  byToken: (token) => axios.get(`${API}/by-token/${encodeURIComponent(token)}`),
  start: (token, payload = {}) =>
    axios.post(`${API}/by-token/${encodeURIComponent(token)}/start`, payload),
  complete: (token, payload = {}) =>
    axios.post(`${API}/by-token/${encodeURIComponent(token)}/complete`, payload),

  // Admin
  adminList: (token, { tier, status, limit } = {}) => {
    const params = new URLSearchParams();
    if (tier) params.set("tier", tier);
    if (status) params.set("status", status);
    if (limit) params.set("limit", String(limit));
    return axios.get(`${API}/admin?${params.toString()}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  adminSummary: (token) =>
    axios.get(`${API}/admin/summary`, { headers: { Authorization: `Bearer ${token}` } }),
};

export function persistTierContext(ctx) {
  try { sessionStorage.setItem(TIER_SESSION_KEY, JSON.stringify(ctx || {})); } catch { /* noop */ }
}
export function readTierContext() {
  try {
    const raw = sessionStorage.getItem(TIER_SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}
export function clearTierContext() {
  try { sessionStorage.removeItem(TIER_SESSION_KEY); } catch { /* noop */ }
}
